import React from "react";
import "./WhyClybourne.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowUpRight } from "@fortawesome/free-solid-svg-icons";

const WhyClybourne = () => {
  const cards = [
    {
      id: 1,
      title: "Fastest Turnaround",
      description: "24-hour reports vs. days elsewhere.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
    {
      id: 2,
      title: "Human + AI Expertise",
      // description: "No generic algorithms— personalized insights.",
      description:
        "Combining business intelligence with human expertise for deeper insights.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
    {
      id: 3,
      title: "Global & Secure",
      description: "GDPR-compliant data protection.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
    {
      id: 4,
      title: "Unmatched Affordability",
      description: "Premium reports at 1/10th the cost.",
      icon: <img src="/assets/images/HowItWorks/Vector.png" alt="↗" />,
    },
  ];

  return (
    <div className="card-grid-container Onlybottom-border">
      <div className="left-text Home-all">
        <h3 className="blue">Why Clybourne</h3>
        <h1 className="pt">
          The Trusted Valuation Platform for 100+ Countries
        </h1>
        <p>
          With advanced algorithms,expert insights,and a user-friendly
          platform,we ensure valuation you can trust.
        </p>
      </div>
      <div className="card-grid">
        {cards.map((card, index) => (
          <div className="card-4" key={index}>
            <div className="icon">{card.icon}</div>
            <h2 className="card-title">{card.title}</h2>
            <p className="card-description">{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyClybourne;
